function initializeReadMore() {
  $('.bottom_description').each(function() {
    var moreContent = $(this).find('.more-content');
  });
}

$(document).ready(function() {
  initializeReadMore();
  $(document).on('click', '.read-more', function() {
    $(this).siblings('.more-content').slideDown();
    $(this).siblings('.read-less').show();
    $(this).hide();
  });
  $(document).on('click', '.read-less', function() {
    $(this).siblings('.more-content').slideUp();
    $(this).siblings('.read-more').show();
    $(this).hide();
  });
  // Assuming you have a way to detect when filters are applied,
  $(document).on('filtersApplied', function() {
    initializeReadMore();
  });
});
